/*
 * @Author: your name
 * @Date: 2020-12-30 09:56:16
 * @LastEditTime: 2021-01-08 11:40:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /amc/src/utils/request.ts
 */
import { UserModule } from '@/store/modules/user'
import axios from 'axios'
import { Message } from 'element-ui'
import { AppModule } from '@/store/modules/app'
import { CustomAxiosConfig } from '@/types/axios'
import router from '@/router/router'

const service = axios.create({
  baseURL: '/aap/api/v1',
  timeout: 150000
})

// Request interceptors
service.interceptors.request.use(
  (config: CustomAxiosConfig) => {
    if (!(typeof config.loading === 'boolean' && config.loading === false)) {
      AppModule.COMMIT_LOADING(true)
    }
    if (router.currentRoute.path === '/economyIndex') {
      return config
    }
    const token = window.sessionStorage.getItem('token')
    const tenantId = window.sessionStorage.getItem('tenantId')
    config.headers.tenantId = tenantId
    config.headers.Authorization = 'bearer ' + token
    return config
  },
  (error) => {
    AppModule.COMMIT_LOADING(false)
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  (response) => {
    const resData = response.data
    const { statusCode } = resData
    AppModule.COMMIT_LOADING(false)
    if (router.currentRoute.path === '/economyIndex') {
      return resData
    }
    if (statusCode !== 0) {
      if (String(statusCode).startsWith('9'))  return resData
      if (document.getElementsByClassName('el-message').length < 1) {
        Message({
          message: resData.errorMsg,
          type: 'error',
          duration: 5 * 1000
        })
      }
      if (statusCode === 3) {
        UserModule.ResetToken()
        router.replace({
          path: '/login'
        })
      }
      Promise.reject((new Error(resData.errorMsg || 'Error')))
    }
    return resData
  },
  (error) => {
    AppModule.COMMIT_LOADING(false)
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
